module.exports = "/wp-content/themes/onnit/script/cart/dist/alphaBrain30TrialUpsellBg-e6c3400e.jpg";